import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/** @clearscore/helpers.device v0.19.10: 2022-12-12 17:54 (assemble v5.5.1) **/
import canUseDom from '@clearscore/helpers.can-use-dom';
import getEnv from '@clearscore/helpers.envs';
import UAParser from 'ua-parser-js';
import currentDevice from 'current-device';
var IOS_WEBVIEW = 'native_ios';
var ANDROID_WEBVIEW = 'native_android';
var IOS_MOBILE = 'ios';
var ANDROID_MOBILE = 'android';
var IOS_TABLET = 'tablet_ios';
var ANDROID_TABLET = 'tablet_android';
var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IOS_WEBVIEW: IOS_WEBVIEW,
  ANDROID_WEBVIEW: ANDROID_WEBVIEW,
  IOS_MOBILE: IOS_MOBILE,
  ANDROID_MOBILE: ANDROID_MOBILE,
  IOS_TABLET: IOS_TABLET,
  ANDROID_TABLET: ANDROID_TABLET
});
var browserParsed = new UAParser().getResult();
var SERVER = 'server';
var NATIVE = 'native';
var MOBILE = 'mobile';
var WEBVIEW = 'WEBVIEW';
function getDevice() {
  if (!canUseDom()) {
    return SERVER;
  }
  var deviceLib = currentDevice.noConflict();
  var device = deviceLib.default || deviceLib;
  var isWebview = getEnv(WEBVIEW);
  var type = isWebview ? NATIVE : device.type;
  if (type === MOBILE) {
    return device.os;
  }
  return "".concat(type, "_").concat(device.os);
}
var isIOSWebview = function isIOSWebview() {
  return getDevice() === IOS_WEBVIEW;
};
var isAndroidWebview = function isAndroidWebview() {
  return getDevice() === ANDROID_WEBVIEW;
};
var isIOSBrowser = function isIOSBrowser() {
  return [IOS_MOBILE, IOS_TABLET].includes(getDevice());
};
var isAndroidBrowser = function isAndroidBrowser() {
  return [ANDROID_MOBILE, ANDROID_TABLET].includes(getDevice());
};
var isDesktop = function isDesktop() {
  return getDevice().includes('desktop');
};
var getBrowser = function getBrowser() {
  var _browser$version;
  var parser = new UAParser();
  var _parser$getResult = parser.getResult(),
    browser = _parser$getResult.browser;
  if (!browser.version) {
    // put within conditional so we don't have to update mocks in a tonne of vertical tests
    var ua = parser.getUA();
    if (ua.indexOf('Pingdom.com_bot') > -1) {
      var versionString = ua.replace('Pingdom.com_bot_version_', '').replace('_(http://www.pingdom.com/)', '');
      var _versionString$split = versionString.split('.'),
        _versionString$split2 = _slicedToArray(_versionString$split, 2),
        _major = _versionString$split2[0],
        _versionString$split3 = _versionString$split2[1],
        _minor = _versionString$split3 === void 0 ? 0 : _versionString$split3;
      var _version = "".concat(_major, ".").concat(_minor);
      return {
        name: 'pingdom',
        version: _version
      };
    }
    return {
      name: 'unknown',
      version: 'unknown'
    };
  }
  var _ref = ((_browser$version = browser.version) === null || _browser$version === void 0 ? void 0 : _browser$version.split('.')) || ['unknown'],
    _ref2 = _slicedToArray(_ref, 2),
    major = _ref2[0],
    _ref2$ = _ref2[1],
    minor = _ref2$ === void 0 ? 0 : _ref2$;
  var version = "".concat(major, ".").concat(minor);
  return {
    name: browser.name,
    version: version
  };
};
getDevice.DEVICE_NAME = "".concat(browserParsed.os.name, " ").concat(browserParsed.browser.name);
export { getDevice as default, constants as deviceConstants, getBrowser, isAndroidBrowser, isAndroidWebview, isDesktop, isIOSBrowser, isIOSWebview };